import { useEffect, useState } from 'react';
import billingService from '../../services/billing';

/**
 * Whether the caller may use the billing console, asked of the server
 * (requireBillingAccess is the real gate). `null` while asking.
 */
export function useBillingAccess() {
  const [state, setState] = useState<{ canBill: boolean | null; isSuperAdmin: boolean }>({ canBill: null, isSuperAdmin: false });
  useEffect(() => {
    let live = true;
    billingService.me()
      .then(res => live && setState({ canBill: !!res.can_bill, isSuperAdmin: !!res.is_super_admin }))
      .catch(() => live && setState({ canBill: false, isSuperAdmin: false }));
    return () => { live = false; };
  }, []);
  return state;
}

// The axios interceptor flattens errors onto err.message.
export const errorText = (err: any, fallback: string): string =>
  err?.message || err?.response?.data?.error?.message || fallback;

export const inputClass =
  'w-full border border-neutral-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500';

